import { Color } from "utils/theme";

export const RootLayout = ({ children }) => {
  return (
    <div
      className="relative h-screen overflow-hidden text-white flex-1"
      style={{
        background: Color.Primary[900],
      }}
    >
      {children}
    </div>
  );
};
